import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

/**
 * Standard enterprise page header:
 * - Title (strong)
 * - Optional subtitle/context line (muted)
 * - Optional right-side actions (buttons, filters, etc.)
 *
 * Usage:
 * <PageHeader title="Dashboard" subtitle="Quick access..." actions={<Button/>} />
 */
export default function PageHeader({ title, subtitle, actions }) {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      justifyContent="space-between"
      sx={{ mb: 2 }}
      spacing={1}
    >
      <Box>
        <Typography variant="h5" sx={{ fontWeight: 900, mb: 0.25 }}>
          {title}
        </Typography>
        {subtitle ? (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        ) : null}
      </Box>

      {actions ? <Box sx={{ mt: { xs: 0.5, sm: 0 } }}>{actions}</Box> : null}
    </Stack>
  );
}
